// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

//////////////////////////////////////////////////////////////////////////////
// Types that are shared between the client and server.
//////////////////////////////////////////////////////////////////////////////

export interface CheckRegistrationRequest {
  registrationID: string;
  barcode: string;
  orgId: string;
}

export enum RegistrationResult {
  VALID = "valid",
  INVALID = "invalid",
  BARCODE_NOT_FOUND = "barcode not found",
  ALREADY_ACTIVATED = "already activated",
}

export interface CheckRegistrationResponse {
  result: RegistrationResult;
  registrationToken?: string;
}
